"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const project_1 = require("~/store/api/project");
const Image_1 = __importDefault(require("./Image"));
function ProjectImage(_a) {
    var { project, currentProjectId, defaultImg } = _a, props = __rest(_a, ["project", "currentProjectId", "defaultImg"]);
    const [src, setSrc] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        let active = true;
        let url;
        setSrc(undefined);
        if (project.id) {
            (0, project_1.getProjectAsset)(project.id, `TSLOTS_${project.referenceNumber}.jpg`)
                .then((blob) => {
                if (active) {
                    url = URL.createObjectURL(blob);
                    setSrc(url);
                }
            })
                .catch(() => {
                if (active) {
                    setSrc(undefined);
                }
            });
        }
        return () => {
            active = false;
            if (url) {
                URL.revokeObjectURL(url);
            }
        };
    }, [project.id, project.referenceNumber, currentProjectId]);
    return react_1.default.createElement(Image_1.default, Object.assign({}, props, { src: src !== null && src !== void 0 ? src : defaultImg, defaultImg: defaultImg }));
}
exports.default = ProjectImage;
ProjectImage.defaultProps = { currentProjectId: undefined };
